import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setDone(true);
    } catch (e2) {
      setErr(typeof e2?.response?.data?.detail === "string" ? e2.response.data.detail : "Something went wrong");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6 py-12">
      <form onSubmit={submit} className="w-full max-w-md sc-card p-8" data-testid="forgot-password-form">
        <div className="sc-label text-[#00E5FF]">Forgot password</div>
        <h2 className="sc-heading text-3xl font-black mb-4 mt-1">Reset your password</h2>
        {done ? (
          <div className="space-y-4">
            <div className="text-sm text-zinc-300" data-testid="forgot-password-success">
              If an account exists for <span className="text-white">{email}</span>, we&apos;ve generated a reset link. Check the server logs for the reset token (or your inbox once email delivery is enabled), then paste the token on the reset page.
            </div>
            <Link to="/reset-password" className="sc-btn w-full inline-block text-center" data-testid="forgot-goto-reset">
              I have a reset token
            </Link>
            <Link to="/login" className="text-xs text-[#00E5FF] hover:underline block text-center">Back to login</Link>
          </div>
        ) : (
          <>
            <p className="text-xs text-zinc-400 mb-4">Enter the email tied to your account. We&apos;ll issue a one-hour, single-use reset token.</p>
            <label htmlFor="forgot-email" className="sc-label block mb-2">Email</label>
            <input
              data-testid="forgot-email"
              id="forgot-email"
              name="email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="sc-input mb-4"
              required
              placeholder="you@example.com"
            />
            {err && <div className="text-[#FF3366] text-xs mb-3" data-testid="forgot-error">{err}</div>}
            <button data-testid="forgot-submit" disabled={busy} className="sc-btn w-full">
              {busy ? "Sending..." : "Send reset link"}
            </button>
            <div className="text-xs text-zinc-400 mt-4 text-center">
              Remembered it? <Link to="/login" className="text-[#00E5FF] hover:underline">Log in</Link>
            </div>
          </>
        )}
      </form>
    </div>
  );
}
